import React from 'react'
import DashboardLayout from '../../components/layouts/dashboardLayout'
import { Breadcrumb } from 'react-bootstrap';
import GalleryList from "../../components/gallery/GalleryList"

let GalleryPictures = () => {


   return (
      <>
         <DashboardLayout>
            <div className="container-fluid mt-4">
               <div className="row">
                  <div className="col-12">
                     <Breadcrumb>
                        <Breadcrumb.Item href="#">
                           Dashboard
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>Gallery</Breadcrumb.Item>
                     </Breadcrumb>
                  </div>
               </div>
               <GalleryList picker={false} />
            </div>
         </DashboardLayout>

      </>
   )
}

export default GalleryPictures